export const environment = {
  production: true,
  authService: 'https://api-activate.virginmobile.co:2021/auth/api/v1/auth/service/session',
  retryService:
    'https://api-activate.virginmobile.co:2020/simactivation/api/v1/simCaptivePortal',
  userService:
    'https://api-activate.virginmobile.co:2021/identifier/api/v1/validateIdentity',
  simActivationService:
    'https://api-activate.virginmobile.co:2020/sim/api/v1/saveActivation2',
  phoneNumberService:
    'https://api-activate.virginmobile.co:2021/virgin30sec/api/v1/line/iccid-ligth',
  physicalCardValidationService:
    'https://api-activate.virginmobile.co:2021/virgin30sec/api/v1/validateSimByICCIDandPuk',
  retryToken: 'e37ee6d1-4cfd-4faf-a6f7-ef981a054412',
  skipUserValidation: true

};
